<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Blog Standard</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/blog-standard" class="h5 text-white">Blog Standard</a>
        </div>
    </div>
</div>

<!-- Blog Start -->
<div class="container-fluid py-5">
  <div class="container py-5">
    <div class="row g-5">
      <!-- Blog Content -->
      <div class="col-lg-8">

      <div class="mb-5">

      <img class="img-fluid w-100 border-radius mb-5"
      [src]="blog.image">

      <h1 class="mb-4">{{blog.title}}</h1>

      <p>
      In the ever-evolving world of digital design, staying updated with the latest UI/UX trends is essential for creating user-friendly websites and apps.
      </p>

      <p>
      One of the biggest focuses in 2025 is personalization. Interfaces are becoming adaptive based on user behavior.
      </p>

      <p>
      Accessibility is no longer optional. Designers must ensure their products are usable for everyone.
      </p>

      </div>

      <!-- Comments -->
      <div class="mb-5">

      <div class="section-title section-title-sm position-relative pb-3 mb-4">
      <h3 class="mb-0">{{comments.length}} Comments</h3>
      </div>

      <div
      class="d-flex mb-4 comments-section"
      *ngFor="let comment of comments">

      <img
      [src]="comment.img"
      class="img-fluid border-radius">

      <div class="ps-3">

      <h6>
      <a href="#">{{comment.name}}</a>
      <small><i>{{comment.date}}</i></small>
      </h6>

      <p>{{comment.text}}</p>

      <button class="btn btn-sm btn-light">Reply</button>

      </div>
      </div>

      </div>

      <!-- Comment Form -->
      <div class="bg-light rounded p-5">

      <div class="section-title section-title-sm position-relative pb-3 mb-4">
      <h3 class="mb-0">Leave A Comment</h3>
      </div>

      <form>

      <div class="row g-3">

      <div class="col-12 col-sm-6">
      <input type="text"
      class="form-control bg-white border-0"
      placeholder="Your Name"
      style="height:55px">
      </div>

      <div class="col-12 col-sm-6">
      <input type="email"
      class="form-control bg-white border-0"
      placeholder="Your Email"
      style="height:55px">
      </div>

      <div class="col-12">
      <input type="text"
      class="form-control bg-white border-0"
      placeholder="Website"
      style="height:55px">
      </div>

      <div class="col-12">
      <textarea
      class="form-control bg-white border-0"
      rows="5"
      placeholder="Comment">
      </textarea>
      </div>

      <div class="col-12">
      <button class="btn btn-primary w-100 py-3">
      Leave Your Comment
      </button>
      </div>

      </div>

      </form>

      </div>

      </div>
      <!-- Sidebar -->
      <div class="col-lg-4">
        <!-- Search -->
        <div class="mb-5">
          <div class="input-group">
            <input type="text" class="form-control p-3" placeholder="Keyword">
            <button class="btn btn-primary px-4">
            <i class="bi bi-search"></i>
            </button>
          </div>
        </div>
        <!-- Categories -->
        <div class="mb-5">

        <div class="section-title section-title-sm position-relative pb-3 mb-4">
          <h3 class="mb-0">Categories</h3>
        </div>

        <div class="d-flex flex-column">

          <a *ngFor="let category of categories" class="h5 fw-medium bg-light border-radius py-2 px-3 mb-2">

          <i class="bi bi-arrow-right me-2"></i>{{category}}

          </a>

        </div>

        </div>
        <!-- Recent Posts -->
        <div class="mb-5">

        <div class="section-title section-title-sm position-relative pb-3 mb-4">
          <h3 class="mb-0">Recent Post</h3>
        </div>

        <div *ngFor="let post of recentPosts" class="d-flex border-radius overflow-hidden mb-3 recent-posts">

          <img class="img-fluid" [src]="post.img">

          <h5 class="d-flex align-items-center bg-light px-3 mb-0">{{post.title}}</h5>

        </div>

        </div>
        <!-- Tags -->
        <div class="mb-5">

          <div class="section-title section-title-sm position-relative pb-3 mb-4">
          <h3 class="mb-0">Tags</h3>
          </div>

          <div class="d-flex flex-wrap m-n1">

          <a
          *ngFor="let tag of tags"
          class="btn btn-light m-1">

          {{tag}}

          </a>

          </div>

        </div>
        <!-- About -->
        <div>

        <div class="section-title section-title-sm position-relative pb-3 mb-4">
          <h3 class="mb-0">About Us</h3>
          </div>

          <div class="bg-light text-left pd-30">

          <p>
          At Delex, we deliver high-performance web solutions that help you grow your business online.
          </p>

          <a class="btn btn-primary border-radius py-2 px-4">
          Read More
          </a>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- Blog End -->